import * as stateManagement from '@/stateManagement';

export const {
  _relativeToStructureLayoutSel,
  relativeToStructureLayoutSel,
  relativeToStructureOrigLayoutSel,
} = stateManagement.stateMapperArgsSelectors.layoutSels;

export type RelativeToStructureLayout = ReturnType<
  typeof relativeToStructureLayoutSel
>;
